module.exports = __webpack_public_path__ + "static/media/11.d73e2591.jpg";